// extracted by mini-css-extract-plugin
export default {"infoBody":"styles_infoBody__tBckz","info":"styles_info__AWVAo","question":"styles_question__IZNe7"};